const URL = {
	INDEX: '',
	HOME: '/',
	ABOUT: '/about',
	CONTACT: '/contact',
	PAYMENT: '/payment',
	PAYMENT_SUCCESS: '/paymentsuccess',
	PAYMENT_FAIL: '/paymentfails',
	RECOVER_TICKET: '/recoverTicket',


	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react'
}

export default URL
